import { AppUser } from 'Src/views/App/App';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import axios from 'Src/helpers/api/axiosInstance';

export function getAllAwardEventPhotos(user: AppUser, awardEventId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: {
        limit: DEFAULT_LIMIT,
        skip: DEFAULT_SKIP
      }
    }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/photos`, config)
    .then(res => res.data);
}

export function addAwardEventPhoto(
  user: AppUser,
  awardEventId: string,
  data: { picUrl: string; originalFileName?: string; accessPreset?: string }
) {
  const { roleSessionKey: key, activeSchoolId } = user;

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/photos`, data, {
      headers: { usid: key }
    })
    .then(res => res.data);
}

export function updateAwardEventPhoto(
  user: AppUser,
  awardEventId: string,
  photoId: string,
  data: Partial<{ accessPreset: string; name: string; description: string }>
) {
  const { roleSessionKey: key, activeSchoolId } = user;

  return axios
    .put(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/photos/${photoId}`, data, {
      headers: { usid: key }
    })
    .then(res => res.data);
}

export function deleteAwardEventPhoto(user: AppUser, awardEventId: string, photoId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  return axios
    .delete(`${window.apiBase}/i/schools/${activeSchoolId}/awardEvents/${awardEventId}/photos/${photoId}`, {
      headers: { usid: key }
    })
    .then(res => res.data);
}
